import React, { type ReactNode } from 'react';

import { CloseAction } from '@pkg/components/modals/primitives/Modal/components/Header/Header';
import { useInstantRef, useOutsideClick } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { useLockBodyScroll } from '@app/helpers';

import { CardWrapper, Content, OuterBackground } from './styles';

export interface ModalProps {
    children: ReactNode;
    onClose(e?): void;
}

export function LargeModal({ children, onClose }: ModalProps) {
    const { tablet } = useMediaQuery();
    const [cardElement, cardRef] = useInstantRef<HTMLDivElement>();

    useLockBodyScroll(true);
    useOutsideClick(cardElement, onClose, { disabled: !tablet });

    return (
        <OuterBackground>
            <CardWrapper ref={cardRef} tabIndex={-1}>
                <CloseAction onClose={onClose} />
                <Content>{children}</Content>
            </CardWrapper>
        </OuterBackground>
    );
}
